export default {
  teachers: [{
    img: 'http://static.geekbang.org/infoq/5a26771a072ba.png?imageView2/0/',
    name: '陈皓',
    company: 'MegaEase 创始人',
    focus: '擅长领域：架构 / 技术管理',
    brief: '前 Amazon 中国研发经理，曾在阿里巴巴商家业务部任资深专家一职。'
  }, {
    img: 'http://static.geekbang.org/infoq/5a26771c9a8af.png?imageView2/0/',
    name: '谢孟军',
    company: '积梦智能创始人',
    focus: '擅长领域：架构 / Go / 大数据',
    brief: 'GopherChina 发起人，beego 作者，《Go Web编程》作者。'
  }, {
    img: 'http://static.geekbang.org/infoq/5a267e7313863.png?imageView2/0/',
    name: '张溪梦',
    company: 'GrowingIO 创始人兼 CEO',
    focus: '擅长领域：大数据',
    brief: '被 DataScienceCentral 评选为“世界前十位前沿数据科学家”。'
  }, {
    img: 'http://static.geekbang.org/infoq/5a26771bc14f1.png?imageView2/0/',
    name: '张彭善',
    company: 'PayPal 大数据研发架构师',
    focus: '擅长领域：资深大数据科学家',
    brief: '硕士毕业于上海交通大学，开源项目 Shifu 和 Guagua 的创始人。'
  }, {
    img: 'http://static.geekbang.org/infoq/5a26771a668d2.png?imageView2/0/',
    name: '彭垚',
    company: '七牛云人工智能实验室负责人',
    focus: '擅长领域：AI',
    brief: '曾担任 IBM 系统与科技实验室研发架构和管理工作多年。'
  }, {
    img: 'http://static.geekbang.org/infoq/5a26771cf300a.png?imageView2/0/',
    name: '李文哲',
    company: '普惠金融首席数据科学家',
    focus: '擅长领域：AI',
    brief: '美国 Texas A&M 大学人工智能硕士，美国南加州大学机器学习博士。'
  }, {
    img: 'http://static.geekbang.org/infoq/5a26771b1773c.png?imageView2/0/',
    name: '黄文坚',
    company: '万惠投资管理大数据算法部总监',
    focus: '擅长领域：AI',
    brief: '明略数据技术合伙人。《TensorFlow实战》作者。'
  }, {
    img: 'http://static.geekbang.org/infoq/5a26771d9c567.png?imageView2/0/',
    name: '黄勇',
    company: '特赞 CTO，Smart 开源框架创始人',
    focus: '擅长领域：技术管理',
    brief: '曾任阿里巴巴系统架构师，《架构探险》图书作者。'
  }, {
    img: 'http://static.geekbang.org/infoq/5a26771ab3801.png?imageView2/0/',
    name: '陈靓',
    company: '南京鹏云网络科技有限公司创始人',
    focus: '擅长领域：云计算架构',
    brief: '千人计划”国家特聘专家。曾就职于美国 Amazon 总部。'
  }, {
    img: 'http://static.geekbang.org/infoq/5a26771b76e26.png?imageView2/0/',
    name: '孙玄',
    company: '转转公司架构算法部负责人',
    focus: '擅长领域：架构',
    brief: '前58 集团技术委员会主席，58 集团高级系统架构师。'
  }]
}
